import * as React from "react"

export const useLocalStorage = (storageName: string) => {
  const storage = localStorage.getItem(storageName)
  const parseStorageData =
    storage && storage !== "undefined" ? JSON.parse(storage) : null

  React.useEffect(() => {
    if (!storage) {
      localStorage.setItem(storageName, JSON.stringify({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setLocalStorage = (data, variant: "rewrite" | "add") => {
    if (variant === "add") {
      let history = {}
      if (storage) {
        history = JSON.parse(storage)
      }
      history = Object.assign(history, data)
      localStorage.setItem(storageName, JSON.stringify(history))
    }

    if (variant === "rewrite") {
      localStorage.setItem(storageName, JSON.stringify(data))
    }
  }
  const removeStorage = () => {
    localStorage.removeItem(storageName)
  }
  return [storage, parseStorageData, setLocalStorage, removeStorage] as const
}
